import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';

export function UnexpectedError() {
    const navigate = useNavigate();

    return (
        <>
            <ContentContainer className="flex-1 space-y-6 text-center lg:flex-none">
                <FeaturedIcon size="lg" color="error" className="mx-auto mb-8" />
                <h1 className="text-2xl font-medium text-gray-900">
                    We're sorry, an unexpected error occured while processing your request
                </h1>
                <p>Please try again or contact support if the problem persists.</p>
            </ContentContainer>
            <StickyBottomBar>
                <Button className="w-full" color="gray" onClick={() => navigate(-1)}>
                    Try Again
                </Button>
            </StickyBottomBar>
        </>
    );
}
